import ConnectWallet from '@/component/ConnectWallet';
import Pools from '@/component/pools/Pools';
import { Box } from '@mui/material';

export default function PoolMain() {
  // const { web3authCall } = useWeb3();
  // const handleTicker = async () => {
  //   if (!web3authCall?.connected() || !web3authCall) {
  //     return;
  //   }
  //   await setCurrencyTicker(web3authCall);
  // };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <ConnectWallet />
        <Pools />
      </Box>
      {/* <Button onClick={handleTicker}>ticker Test</Button> */}
      {/* <br />
      Pools
      <br />
      ---------------------------------------------------------------------------------
      <br />
      Portfolio
      <br />
      <PortfolioMain /> */}
    </>
  );
}
